import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  serializeToGetParams(object): string {
    let str = '';
    for (const key in object) {
      if (object.hasOwnProperty(key)) {
        if (encodeURIComponent(object[key])) {
          if (str !== '') {
            str += '&';
          }
          str += key + '=' + encodeURIComponent(object[key]);
        }
      }
    }
    return str;
  }
}
